// extracted by mini-css-extract-plugin
export default {"dialog":"OrganisationHomepage_dialog__7z2V2","actions":"OrganisationHomepage_actions__gFopm"};